export default __webpack_public_path__ + "static/media/iot2g.10766a93.jpg";